export default __webpack_public_path__ + "static/image-37-e3d6f37afb6c721ac62a69060242eff7.jpg";